import { Component, Prop, Vue } from 'vue-property-decorator'
import { i18n } from '@/i18n'

export const colsProps = {
  'label-cols': 12,
  'label-cols-sm': 4,
  'label-cols-md': 3,
  'label-cols-lg': 2,
  'label-cols-xl': 2
}

/**
 * The getter `computedGroupBindings` will include the `label-for` prop.
 * Populating the `id` prop in the inherited component will for the bv-group
 * component to use a `label` tag instead of a `legend` tag for the label.
 * Ensure you set the `id` to your `input` as well.
 *
 * @example
 *
 * // using IdMixin
 * created () {
 *  this.labelId = this.uniqueId()
 * }
 */
@Component
export default class extends Vue {
  labelId?: string

  @Prop({ type: String, default: '' })
  label!: string

  @Prop({ type: Boolean, default: false })
  labelSrOnly!: boolean

  @Prop({ type: Boolean, default: false })
  labelBold!: boolean

  @Prop({ type: String, default: '' })
  description!: string

  @Prop({ type: Boolean, default: false })
  required!: boolean

  @Prop({ type: Boolean, default: false })
  horizontal!: boolean

  @Prop({ type: String, default: '' })
  invalidFeedback!: string

  @Prop({
    type: String,
    default: 'left',
    validator: value => ['left', 'center', 'right'].includes(value)
  })
  align!: string

  get computedGroupBindings () {
    return {
      ...(this.horizontal && colsProps),
      ...this.alignProps,
      description: this.computedDescription,
      label: this.computedLabel,
      labelSrOnly: this.labelSrOnly,
      labelClass: {
        required: this.required,
        optional: !this.required,
        'font-weight-bold': this.labelBold,
      },
      labelFor: this.labelId,
      invalidFeedback: this.computedInvalidFeedback,
    }
  }

  get computedLabel () {
    return i18n.t(this.label)
  }

  get computedDescription () {
    return i18n.t(this.description)
  }

  get computedInvalidFeedback () {
    return i18n.t(this.invalidFeedback)
  }

  get alignProps () {
    return {
      labelAlign: 'left',
      labelAlignSm: this.align,
    }
  }
}
